import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Content from './Content.vue'

interface Props {
  placement?: string;
  offset?: number | string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Customize',
  props: {
    placement: { default: 'top' },
    offset: { default: 12 }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createBlock(_component_el_popover, {
    trigger: "hover",
    placement: _ctx.placement,
    "popper-class": "dialog-wrap-hover",
    width: "5.6rem",
    offset: _ctx.offset
  }, {
    reference: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    default: _withCtx(() => [
      _createVNode(Content)
    ]),
    _: 3
  }, 8, ["placement", "offset"]))
}
}

})